var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MissionDetailNavigationGraphicsListGen',{attrs:{"uiid":_vm.uiid,"isleft":_vm.isleft,"mission":_vm.currentDetailMission.mission,"tabState":_vm.currentDetailMission},on:{"selectGraph":function($event){return _vm.selectGraph($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }